/*
 * @Author: zhu.huijun
 * @Date: 2021-05-18 14:23:12
 * @Last Modified by: way
 * @Last Modified time: 2021-12-20 14:43:14
 */
/**
 * 渲染套餐数据的组件
 * <OfferCard cardKey={cardKey} title={offerDetail => Reatc.Node || ''} dataGroup={dataGroup} renderItemData={renderItemData} defaultSelect={defaultSelect} onClick={offerDetail => onClick(offerDetail)}/>
 * @param {String} cardKey 每个card唯一标识的Key =》dataGroup.map(it => it[key])
 * @param {array} dataGroup 所有卡片的数据
 * @param {object} defaultSelect 默认选中项
 * @param {function(offerDetail)} onClick 点击事件
 */
import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import PortalCard from './PortalCard';
import SubsPlanCard from './SubsPlanCard';
import styles from './index.module.less';

const PortalCardList = props => {
  const { cardKey, defaultCardId, dataGroup = [], onClick, onDppChange, selectPlanWithDpp } = props;
  const [selectInfo, setSelectInfo] = useState({});

  const hasSelected = data => {
    if (!isEmpty(selectInfo)) {
      return selectInfo[cardKey] === data[cardKey];
    }
    return defaultCardId === data[cardKey];
  };

  const handleSelected = data => {
    const comboUnitOfferDtoList = get(data, 'offerExtMap.comboUnitOfferDtoList') || [];
    const maskFlag = comboUnitOfferDtoList.some(comboUnitOfferItem => comboUnitOfferItem.isCannotOrder === 'Y');
    setSelectInfo(maskFlag ? {} : data);
    onClick(maskFlag ? {} : data);
  };

  return (
    <div className={styles.offerCardListCom}>
      {
        (dataGroup || []).map(item => (
          selectPlanWithDpp ?
            (
              <SubsPlanCard
                key={item[cardKey]}
                cardInfo={item}
                isSelected={hasSelected(item)}
                onClick={() => handleSelected(item)}
                onDppChange={onDppChange}
              />
            )
            :
            (
              <PortalCard
                key={item[cardKey]}
                cardInfo={item}
                isSelected={hasSelected(item)}
                onClick={() => handleSelected(item)}
              />
            )
        ))
      }
    </div>
  );
};

export default PortalCardList;
